import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { api, errMsg } from '../api';
import { usePortal } from '../PortalAuth';
import { AREAS, NAV, areasOf, canSee } from '../shells/nav';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../../components/ui/dialog';
import Infographic from '../legal/Infographic';
import { VARIANTS } from './areaButtonVariants';

const PREVIEW = { security: 'travel', cyber: 'databreach' };
const TONES = { financial: '#B8941F', compliance: '#3E7CB1', security: '#2E8B57', cyber: '#B42318' };

export default function AreaButtons({ variant = 'a', testPrefix = 'area' }) {
  const { user } = usePortal();
  const navigate = useNavigate();
  const [sent, setSent] = useState({});
  const [preview, setPreview] = useState(null);
  const enabled = areasOf(user);
  const request = async (id) => {
    try { await api.post('/requests/area-activation', { area: id }); setSent({ ...sent, [id]: true }); setPreview(null); toast.success('Richiesta inviata: ti contatteremo a breve'); }
    catch (e) { toast.error(errMsg(e)); }
  };
  const items = AREAS.filter((a) => a.id !== 'aml_api').map((a) => {
    const on = enabled.includes(a.id);
    const first = a.items.find((id) => canSee(user, id));
    const click = () => (on ? first && navigate(NAV.find((n) => n.id === first).to) : PREVIEW[a.id] ? setPreview(a) : !sent[a.id] && request(a.id));
    return { ...a, on, tone: TONES[a.id], click, status: sent[a.id] ? 'Richiesta inviata' : 'Attiva' };
  });
  const Render = VARIANTS[variant];
  return (
    <>
      <Render items={items} testPrefix={testPrefix} />
      <Dialog open={!!preview} onOpenChange={() => setPreview(null)}>
        <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto" data-testid="area-preview-dialog">
          <DialogHeader>
            <DialogTitle>{preview?.label}</DialogTitle>
            <DialogDescription>{preview?.text}</DialogDescription>
          </DialogHeader>
          {preview && <div><Infographic kind={PREVIEW[preview.id]} full /></div>}
          {preview && <button onClick={() => !sent[preview.id] && request(preview.id)} disabled={sent[preview.id]} className="self-start px-5 py-2.5 rounded-full bg-[#D4AF37] text-black text-sm font-medium hover:bg-[#c9a42f] transition-colors disabled:opacity-60" data-testid="area-preview-request">{sent[preview.id] ? 'Richiesta inviata' : 'Richiedi attivazione'}</button>}
        </DialogContent>
      </Dialog>
    </>
  );
}
